import { render, staticRenderFns } from "./rental-item.vue?vue&type=template&id=0f7e3220&scoped=true&"
import script from "./rental-item.vue?vue&type=script&lang=js&"
export * from "./rental-item.vue?vue&type=script&lang=js&"
import style0 from "./rental-item.vue?vue&type=style&index=0&id=0f7e3220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e3220",
  null
  
)

export default component.exports